// RTL utility functions for delivery web app

// List of RTL languages
export const RTL_LANGUAGES = ["ar", "he", "fa", "ur"];

/**
 * Check if the current language is RTL
 * @param {string} language - Language code (e.g., 'ar', 'en')
 * @returns {boolean} - True if language is RTL
 */
export const isRTL = (language) => {
  if (!language) return false;
  return RTL_LANGUAGES.includes(language.toLowerCase());
};

/**
 * Get text direction based on language
 * @param {string} language - Language code
 * @returns {string} - 'rtl' or 'ltr'
 */
export const getDirection = (language) => {
  return isRTL(language) ? "rtl" : "ltr";
};

/**
 * Get toast position based on language direction
 * @param {string} language - Language code
 * @returns {string} - Toast position for Sonner
 */
export const getToastPosition = (language) => {
  return isRTL(language) ? "bottom-left" : "bottom-right";
};

/**
 * Get RTL-aware CSS classes
 * @param {string} language - Language code
 * @returns {object} - Object with RTL-aware class names
 */
export const getRTLClasses = (language) => {
  const rtl = isRTL(language);

  return {
    textAlign: rtl ? "text-right" : "text-left",
    marginLeft: rtl ? "mr-auto" : "ml-auto",
    marginRight: rtl ? "ml-auto" : "mr-auto",
    paddingLeft: rtl ? "pr-4" : "pl-4",
    paddingRight: rtl ? "pl-4" : "pr-4",
    borderLeft: rtl ? "border-r" : "border-l",
    borderRight: rtl ? "border-l" : "border-r",
    float: rtl ? "float-right" : "float-left",
    direction: getDirection(language),
  };
};

/**
 * Apply RTL direction to document
 * @param {string} language - Language code
 */
export const applyRTLToDocument = (language) => {
  if (typeof document !== "undefined") {
    document.documentElement.dir = getDirection(language);
    document.documentElement.lang = language;
  }
};
